import React, { useState, KeyboardEvent, useEffect } from "react";
import { Button, Col, DatePicker, Form, Input, message, Row, Tag, Checkbox } from "antd";
import brandOperationApi from "@api/brandOperationApi";
import { FetchVendorListParam } from "@api/productApi";
import InfiniteScrollSelect from "@component/Common/InfiniteScrollSelect";
import {
  fetchVendorList,
  IWBrandState,
  resetIntoWarehouseParams,
  updateIntoWarehouseParams,
} from "@redux/brandOperation/intoWarehouseBrandSlice";
import { useDispatch, useSelector } from "react-redux";
import { FilterWrapper, FlexBox } from "src/styles/common";
import styled from "styled-components";

const CustomButton = styled(Button)`
  margin-right: 10px;
`;

const Filter = (props: { show: boolean }) => {
  const { show } = props;
  const dispatch = useDispatch();
  const { intoWarehouseParams } = useSelector(IWBrandState);

  const [form] = Form.useForm();
  const [inputValue, setInputValue] = useState(""); // sku input
  const [tags, setTags] = useState<string[]>([]); // multiple sku tags

  const onSubmit = () => {
    const formValues = form.getFieldsValue();

    let valid = false;
    Object.keys(formValues).forEach((key) => {
      const item = formValues[key];
      if (item) valid = true;
      if (key === "skus" && inputValue) {
        valid = true;
      }
    });
    if (!valid) return;

    let skusParsed;
    const skus = form.getFieldValue("skus");
    if (inputValue && skus) skusParsed = `${inputValue},${skus}`;
    if (inputValue && !skus) skusParsed = `${inputValue}`;
    if (!inputValue) skusParsed = skus;

    const { stoNumber, specDate, supplyChain, noStockinDate, stockinDate } = formValues;

    const params = {
      ...intoWarehouseParams,
      skus: skusParsed || undefined,
      stoNumber,
      specDateAfter: specDate && specDate[0]?.format("YYYY-MM-DD"),
      specDateBefore: specDate && specDate[1]?.format("YYYY-MM-DD"),
      stockinDateAfter: stockinDate && stockinDate[0]?.format("YYYY-MM-DD"),
      stockinDateBefore: stockinDate && stockinDate[1]?.format("YYYY-MM-DD"),
      supplyChain,
      noStockinDate,
    };
    dispatch(updateIntoWarehouseParams(params));
  };

  const onReset = () => {
    form.resetFields();
    setInputValue("");
    setTags([]);
    dispatch(resetIntoWarehouseParams());
  };

  const handleSkuInputPressEnter = (e: KeyboardEvent<HTMLInputElement>) => {
    const { value } = e.target as HTMLInputElement;
    if (tags.some((tag) => tag === value)) {
      message.warning("此商品條碼已加入");
      return;
    }
    setTags([...tags, inputValue]);
    setInputValue("");
  };

  const handleClose = (removedTag: string) => {
    const newTags = tags.filter((tag) => tag !== removedTag);
    setTags(newTags);
  };

  const fetchSupplyChainList = async (searchParams: FetchVendorListParam) => {
    const response = await brandOperationApi.fetchVendorList(searchParams);
    return response;
  };

  useEffect(() => {
    form.setFieldsValue({ skus: tags.toString() });
  }, [form, tags]);

  useEffect(() => {
    dispatch(fetchVendorList(""));
  }, [dispatch]);

  return (
    <FilterWrapper show={show}>
      <Form colon={false} labelAlign="left" form={form} initialValues={{}}>
        <Row gutter={[16, 8]}>
          <Col span={6} />
          <Col span={8} />
          <Col flex="0 0 66px" style={{ height: "31px" }} />
          <Col flex="auto">
            {tags.map((tag) => (
              <span key={tag}>
                <Tag
                  closable
                  onClose={(e) => {
                    e.preventDefault();
                    handleClose(tag);
                  }}
                >
                  {tag}
                </Tag>
              </span>
            ))}
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={6}>
            <Form.Item label="WMS編號" name="stoNumber">
              <Input allowClear />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="供應商名稱" name="supplyChain">
              <InfiniteScrollSelect fetchListApi={fetchSupplyChainList} showSearch allowClear />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="SKU(品號)">
              <Input
                onChange={(e) => setInputValue(e.target.value)}
                onPressEnter={handleSkuInputPressEnter}
                placeholder="可用Enter加入多筆"
                value={inputValue}
                allowClear
              />
            </Form.Item>
            <Form.Item name="skus" noStyle />
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={6}>
            <Form.Item label="預期進倉日期" name="specDate">
              <DatePicker.RangePicker />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item label="實際進倉日期" name="stockinDate">
              <DatePicker.RangePicker />
            </Form.Item>
          </Col>
        </Row>
        <Col>
          <Form.Item name="noStockinDate" valuePropName="checked">
            <Checkbox>顯示未有實際入庫時間的進倉單</Checkbox>
          </Form.Item>
        </Col>
      </Form>
      <FlexBox>
        <CustomButton onClick={onReset}>清除篩選條件</CustomButton>
        <Button type="primary" onClick={onSubmit}>
          套用
        </Button>
      </FlexBox>
    </FilterWrapper>
  );
};
export default Filter;
